/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ERPFivaldiIntegrationSettings = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ERPFivaldiIntegrationSettings model module.
   * @module model/ERPFivaldiIntegrationSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ERPFivaldiIntegrationSettings</code>.
   * @alias module:model/ERPFivaldiIntegrationSettings
   * @class
   */
  var exports = function() {
    var _this = this;






















  };

  /**
   * Constructs a <code>ERPFivaldiIntegrationSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ERPFivaldiIntegrationSettings} obj Optional instance to populate.
   * @return {module:model/ERPFivaldiIntegrationSettings} The populated <code>ERPFivaldiIntegrationSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('CreatedBy')) {
        obj['CreatedBy'] = ApiClient.convertToType(data['CreatedBy'], 'Integer');
      }
      if (data.hasOwnProperty('FivaldiUserName')) {
        obj['FivaldiUserName'] = ApiClient.convertToType(data['FivaldiUserName'], 'String');
      }
      if (data.hasOwnProperty('FivaldiPassword')) {
        obj['FivaldiPassword'] = ApiClient.convertToType(data['FivaldiPassword'], 'String');
      }
      if (data.hasOwnProperty('FivaldiSchemaNumber')) {
        obj['FivaldiSchemaNumber'] = ApiClient.convertToType(data['FivaldiSchemaNumber'], 'Integer');
      }
      if (data.hasOwnProperty('FivaldiOrganizationIdentifier')) {
        obj['FivaldiOrganizationIdentifier'] = ApiClient.convertToType(data['FivaldiOrganizationIdentifier'], 'String');
      }
      if (data.hasOwnProperty('CredentialsPrivate')) {
        obj['CredentialsPrivate'] = ApiClient.convertToType(data['CredentialsPrivate'], 'Boolean');
      }
      if (data.hasOwnProperty('SyncActive')) {
        obj['SyncActive'] = ApiClient.convertToType(data['SyncActive'], 'Boolean');
      }
      if (data.hasOwnProperty('SyncProducts')) {
        obj['SyncProducts'] = ApiClient.convertToType(data['SyncProducts'], 'Boolean');
      }
      if (data.hasOwnProperty('SyncProductsLastDate')) {
        obj['SyncProductsLastDate'] = ApiClient.convertToType(data['SyncProductsLastDate'], 'Date');
      }
      if (data.hasOwnProperty('SyncCustomers')) {
        obj['SyncCustomers'] = ApiClient.convertToType(data['SyncCustomers'], 'Boolean');
      }
      if (data.hasOwnProperty('SyncCustomersLastDate')) {
        obj['SyncCustomersLastDate'] = ApiClient.convertToType(data['SyncCustomersLastDate'], 'Date');
      }
      if (data.hasOwnProperty('SyncOrders')) {
        obj['SyncOrders'] = ApiClient.convertToType(data['SyncOrders'], 'Boolean');
      }
      if (data.hasOwnProperty('SyncOrdersLastDate')) {
        obj['SyncOrdersLastDate'] = ApiClient.convertToType(data['SyncOrdersLastDate'], 'Date');
      }
      if (data.hasOwnProperty('SyncSales')) {
        obj['SyncSales'] = ApiClient.convertToType(data['SyncSales'], 'Boolean');
      }
      if (data.hasOwnProperty('SyncSalesLastDate')) {
        obj['SyncSalesLastDate'] = ApiClient.convertToType(data['SyncSalesLastDate'], 'Date');
      }
      if (data.hasOwnProperty('SyncAccounting')) {
        obj['SyncAccounting'] = ApiClient.convertToType(data['SyncAccounting'], 'Boolean');
      }
      if (data.hasOwnProperty('SyncAccountingLastDate')) {
        obj['SyncAccountingLastDate'] = ApiClient.convertToType(data['SyncAccountingLastDate'], 'Date');
      }
      if (data.hasOwnProperty('CompanyLegalEntityID')) {
        obj['CompanyLegalEntityID'] = ApiClient.convertToType(data['CompanyLegalEntityID'], 'Integer');
      }
      if (data.hasOwnProperty('IsInitialRunDone')) {
        obj['IsInitialRunDone'] = ApiClient.convertToType(data['IsInitialRunDone'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} CreatedBy
   */
  exports.prototype['CreatedBy'] = undefined;
  /**
   * @member {String} FivaldiUserName
   * @default ''
   */
  exports.prototype['FivaldiUserName'] = '';
  /**
   * @member {String} FivaldiPassword
   * @default ''
   */
  exports.prototype['FivaldiPassword'] = '';
  /**
   * @member {Integer} FivaldiSchemaNumber
   */
  exports.prototype['FivaldiSchemaNumber'] = undefined;
  /**
   * @member {String} FivaldiOrganizationIdentifier
   * @default ''
   */
  exports.prototype['FivaldiOrganizationIdentifier'] = '';
  /**
   * @member {Boolean} CredentialsPrivate
   */
  exports.prototype['CredentialsPrivate'] = undefined;
  /**
   * @member {Boolean} SyncActive
   */
  exports.prototype['SyncActive'] = undefined;
  /**
   * @member {Boolean} SyncProducts
   */
  exports.prototype['SyncProducts'] = undefined;
  /**
   * @member {Date} SyncProductsLastDate
   */
  exports.prototype['SyncProductsLastDate'] = undefined;
  /**
   * @member {Boolean} SyncCustomers
   */
  exports.prototype['SyncCustomers'] = undefined;
  /**
   * @member {Date} SyncCustomersLastDate
   */
  exports.prototype['SyncCustomersLastDate'] = undefined;
  /**
   * @member {Boolean} SyncOrders
   */
  exports.prototype['SyncOrders'] = undefined;
  /**
   * @member {Date} SyncOrdersLastDate
   */
  exports.prototype['SyncOrdersLastDate'] = undefined;
  /**
   * @member {Boolean} SyncSales
   */
  exports.prototype['SyncSales'] = undefined;
  /**
   * @member {Date} SyncSalesLastDate
   */
  exports.prototype['SyncSalesLastDate'] = undefined;
  /**
   * @member {Boolean} SyncAccounting
   */
  exports.prototype['SyncAccounting'] = undefined;
  /**
   * @member {Date} SyncAccountingLastDate
   */
  exports.prototype['SyncAccountingLastDate'] = undefined;
  /**
   * @member {Integer} CompanyLegalEntityID
   * @default 0
   */
  exports.prototype['CompanyLegalEntityID'] = 0;
  /**
   * @member {Boolean} IsInitialRunDone
   * @default false
   */
  exports.prototype['IsInitialRunDone'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


